// extracted by mini-css-extract-plugin
export var circle = "_fs-1";
export var exitConfirmationModal = "_fs-5";
export var iframe = "_fs-0";
export var offline = "_fs-3";
export var online = "_fs-2";
export var workstationSelectError = "_fs-4";